import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface AddToCalendarIconProps extends SvgIconProps {}

export const AddToCalendarIcon = (
  props: AddToCalendarIconProps,
): ReactElement => {
  const { style, ...rest } = props;
  return (
    <SvgIcon
      style={{ fontSize: '1em', ...style }}
      {...rest}
      width="35"
      height="35"
      viewBox="0 0 35 35"
    >
      <g transform="translate(0 0)">
        <g
          transform="translate(0 0)"
          fill="#f0f0f0"
          stroke="#fff"
          strokeWidth="1"
        >
          <rect width="35" height="35" rx="17.5" stroke="none" />
          <rect x="0.5" y="0.5" width="34" height="34" rx="17" fill="none" />
        </g>
      </g>
      <g transform="translate(7.205 7.997)">
        <path
          d="M21.985,6.75h-1.98V7.938a.4.4,0,0,1-.4.4h-.792a.4.4,0,0,1-.4-.4V6.75h-9.5V7.938a.4.4,0,0,1-.4.4H7.731a.4.4,0,0,1-.4-.4V6.75H5.355a1.986,1.986,0,0,0-1.98,1.98V22.192a1.986,1.986,0,0,0,1.98,1.98h16.63a1.986,1.986,0,0,0,1.98-1.98V8.73A1.986,1.986,0,0,0,21.985,6.75Zm.4,14.849a.993.993,0,0,1-.99.99H5.949a.993.993,0,0,1-.99-.99V12.689a.4.4,0,0,1,.4-.4h16.63a.4.4,0,0,1,.4.4Z"
          transform="translate(-3.375 -5.166)"
          fill="#a7a7a7"
        />
        <path
          d="M10.584,4.9a.4.4,0,0,0-.4-.4H9.4a.4.4,0,0,0-.4.4V6.084h1.584Z"
          transform="translate(-5.04 -4.5)"
          fill="#a7a7a7"
        />
        <path
          d="M26.334,4.9a.4.4,0,0,0-.4-.4h-.792a.4.4,0,0,0-.4.4V6.084h1.584Z"
          transform="translate(-9.703 -4.5)"
          fill="#a7a7a7"
        />
      </g>
    </SvgIcon>
  );
};

export default AddToCalendarIcon;
